<template>
	<div>
		<el-dialog title="恢复默认设置" :visible="dialogDefault" width="392px" @close="$store.commit('gotState', {key: 'dialogDefault', data: false})">
			<div class="tip flexJA flexFs">
				<img src="@/assets/images/33.png">
				<div>此操作将永久删除您在当前页的个人自定义设置，此操作不可撤销，请务必谨慎操作。</div>
			</div>
			<div class="btns flexJA">
				<div class="btn flexJA" @click="$store.commit('gotState', {key: 'dialogDefault', data: false})">取消</div>
				<div class="btn btn-1 flexJA" @click="restore">恢复默认</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		data() {
			return {
			}
		},
		computed: {
			...mapState({
				update: (state) => state.update,
				UpdateTIme: (state) => state.UpdateTIme,
				Upgrade: (state) => state.Upgrade,
				equipmentStatus: (state) => state.equipmentStatus,
				dialogDefault: (state) => state.dialogDefault,
			}),
		},
		mounted() {
		},
		methods: {
			restore() {
				// this.hpVolumeStatus = true;
				// this.hpVolumeValue = 20;
				// this.mpVolumeStatus = true;
				// this.mpVolumeValue = 20;
				// this.encStatus = true;
				// this.sidetoneStatus = true;
			
				// this.dialogDefault = false;
			},
		}
	}
</script>

<style scoped lang="scss">
	@import '@/assets/css/deep.scss';
</style>